<div class="pan-reveal" #root>
  <!-- left reveal slot (generic) -->
  <div class="pan-reveal-actions left" #leftActions>
    <ng-content select="[reveal-left]"></ng-content>
  </div>

  <!-- right reveal slot (generic) - keep a fallback 'reveal' selector for compatibility) -->
  <div class="pan-reveal-actions right" #rightActions>
    <ng-content select="[reveal-right],[reveal]"></ng-content>
  </div>

  <div
    class="pan-reveal-content"
    panGesture
    (panStart)="onPanStart()"
    (panMove)="onPanMove($event)"
    (panEnd)="onPanEnd($event)"
    [style.transform]="transform"
  >
    <ng-content></ng-content>
  </div>
</div>
